module.exports = __webpack_public_path__ + "static/media/adsk-products working.1767cba4.txt";